import type { Action, Dispatch, Store } from '@reduxjs/toolkit';
import { ReactiveController, ReactiveControllerHost } from 'lit';
import { Unsubscribe } from 'redux';

export abstract class ReduxController<S> implements ReactiveController {
  protected host: ReactiveControllerHost;
  protected store: Store<S, Action>;
  private _state: S;
  private _storeUnsubscribe!: Unsubscribe;
  private _dispatch: Dispatch<Action>;
  
  public initialized = false;

  constructor(host: ReactiveControllerHost, store: Store<S, Action>) {
    (this.host = host).addController(this);
    this.store = store;
    this._state = store.getState();
    this._dispatch = store.dispatch;
  }

  get dispatch(): Dispatch<Action> {
    return this._dispatch;
  }

  get state(): S {
    return this._state;
  }
  
  hostConnected(): void {
    this.initialize();
  }

  hostDisconnected(): void {
    this._storeUnsubscribe?.call(this);
  }

  initialize(): void {
    this.initialized = true;
    this._storeUnsubscribe = this.store.subscribe(() =>
      this.stateChanged(this.store.getState(), false)
    );
    this.stateChanged(this.store.getState(), true);
  }

  abstract stateChanged(state: S, forceUpdate: boolean): void;

  protected updateState(state: S): void {
    this._state = state;
  }
}
